import { requestHandler } from "../lib/utils/network-client";

export function getManagingTrustee() {
  return requestHandler("/managing-trustee");
}

export function updateManagingTrustee(payload) {
  return requestHandler("/managing-trustee", {
    method: "PUT",
    body: payload
  });
}
